import { Component, Input } from '@angular/core';

import { AppContext } from './../../shared';

@Component({
  selector: 'arrival-message',
  template: require('./arrival-message.component.html'),
  styles: [require('./arrival-message.component.scss')]
})

export class ArrivalMessageComponent {
  @Input() title: string;
  @Input() content: string;

  constructor(private app: AppContext) {
    // Do stuff
  }

  close() {
    this.app.hideArrivalMessage();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/arrival-message/arrival-message.component.ts